import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var TagIcon = function TagIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsxs("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "TagIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: [jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M1 1.824C1 1.369 1.369 1 1.824 1h6.443c.218 0 .428.087.582.241l5.537 5.538a2.113 2.113 0 0 1 0 2.979l-.584-.58.582.582-4.62 4.62a2.113 2.113 0 0 1-2.988 0L1.24 8.851A.82.82 0 0 1 1 8.27zm12.218 6.772a.465.465 0 0 0 0-.655L7.926 2.647H2.647v5.28l5.293 5.289a.47.47 0 0 0 .508.102.5.5 0 0 0 .151-.101z",
      clipRule: "evenodd"
    }), jsx("path", {
      fill: "currentColor",
      d: "M5.941 4.912a1.03 1.03 0 1 1-2.059 0 1.03 1.03 0 0 1 2.06 0"
    })]
  }));
};

export { TagIcon };
